import * as React from "react"

const ExternalLinkSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M9.00101 0.00390625V2.00391H2.00101V16.0039H16.001V9.00391H18.001V16.0039C18.001 17.1039 17.101 18.0039 16.001 18.0039H2.00101C0.891007 18.0039 0.00100708 17.1039 0.00100708 16.0039V2.00391C0.00100708 0.903906 0.891007 0.00390638 2.00101 0.00390625H9.00101ZM18.001 0.00390625V7.00391H16.001V3.41406L6.17093 13.2441L4.76077 11.834L14.5909 2.00391H11.001V0.00390625H18.001Z" fill="#3358CC" />
  </svg>
)
export default ExternalLinkSVG
